import { Routes, Route, Navigate } from 'react-router-dom';
import OperationsLayout from './layout';
import LoginPage from '@/pages/LoginPage';
import DashboardPage from '@/pages/DashboardPage';
import SchoolReport from '@/pages/GeniusReport/SchoolReport';
import { APP_ROOT_PATH, LOGIN_PATH, SCHOOL_REPORT_PATH } from '@/config/paths';
import { AuthGuard } from '@/guards/AuthGuard';

export function AppRoutes() {
  return (
    <Routes>
      <Route path={LOGIN_PATH} element={<LoginPage />} />
      <Route path={APP_ROOT_PATH} element={<OperationsLayout />}>
        <Route
          index
          element={
            <AuthGuard>
              <DashboardPage />
            </AuthGuard>
          }
        />
      </Route>
      <Route
        path={SCHOOL_REPORT_PATH}
        element={
          <AuthGuard>
            <SchoolReport />
          </AuthGuard>
        }
      />
      <Route path="*" element={<Navigate to={APP_ROOT_PATH} replace />} />
    </Routes>
  );
}
